// src/components/Footer.js
import React, { useState } from 'react';
import { Box, Typography, IconButton, Button } from '@mui/material';
import { styled } from '@mui/system';
import TwitterIcon from '@mui/icons-material/Twitter';
import { ReactComponent as DiscordLogo } from '../assets/discord_logo.svg'; // Import your Discord logo
import mindguardLogo from '../assets/mindguard_logo_final.png'; // Import the MINDguard logo
import mindaoLogo from '../assets/Mindao_logo_extracted.png';
import AccessCodeModal from './AccessCodeModal';

const FooterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(4, 0),
  textAlign: 'center',
  marginTop: 'auto', // Pushes footer content to the bottom
}));

const SocialMediaIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const DiscordIconStyled = styled(DiscordLogo)(({ theme }) => ({
  width: '24px',
  height: '24px',
  fill: theme.palette.primary.main, // Ensures the Discord logo matches your theme's primary color
}));

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);


  const handleAddMindguardClick = () => {
    window.open(
      'https://discord.com/oauth2/authorize?client_id=1295817369163399259&permissions=947308850288&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Flogin-callback&integration_type=0&scope=applications.commands+bot',
      '_blank'
    );
  };

  return (
    <>
      <FooterContainer>
        <Typography
          variant="body1"
          gutterBottom
          sx={{ color: (theme) => theme.palette.text.secondary }}
        >
          © {new Date().getFullYear()} MINDguard. All rights reserved.
        </Typography>

        <SocialMediaIcons>
          <IconButton
            href="https://x.com/MINDaosol" // Replace with your Twitter URL
            aria-label="Twitter"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'primary.main' }}
          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            href="https://discord.gg/your-discord-invite" // Replace with your Discord invite link
            aria-label="Discord"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'primary.main' }}
          >
            <DiscordIconStyled />
          </IconButton>
          {/* Add MINDao Logo */}
          <IconButton
            onClick={() => setIsModalOpen(true)}
            aria-label="MINDao"
            sx={{ color: 'primary.main' }}
          >
            <Box
              component="img"
              src={mindaoLogo}
              alt="MINDao Logo"
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </SocialMediaIcons>

        {/* "Add MINDguard" Button */}
        <Button
          color="primary"
          variant="outlined"
          onClick={handleAddMindguardClick}
          startIcon={
            <Box
              component="img"
              src={mindguardLogo}
              alt="MINDguard Logo"
              sx={{ width: '20px', height: '20px' }}
            />
          }
          sx={{
            marginTop: 3,
            fontFamily: 'Poppins, sans-serif',
            textTransform: 'none',
            borderColor: 'primary.main',
            color: 'primary.main',
            '&:hover': {
              borderColor: 'primary.light',
              backgroundColor: 'rgba(154, 192, 205, 0.1)',
            },
          }}
        >
          Add MINDguard
        </Button>
      </FooterContainer>

      {/* Access Code Modal */}
      <AccessCodeModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Footer;

